// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension="
// @generated from file bundles/v1/rules.proto (package bundles.v1, syntax proto3)

import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2'
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2'
import type { Duration, Value } from '@bufbuild/protobuf/wkt'
import { file_google_protobuf_duration, file_google_protobuf_struct } from '@bufbuild/protobuf/wkt'
// biome-ignore lint/suspicious/noShadowRestrictedNames: automatically generated file
import type { Date } from '../../google/type/date_pb'
import { file_google_type_date } from '../../google/type/date_pb'
import type { Message } from '@bufbuild/protobuf'

/**
 * Describes the file bundles/v1/rules.proto.
 */
export const file_bundles_v1_rules: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [file_google_protobuf_duration, file_google_protobuf_struct, file_google_type_date]
  )

/**
 * Location represents a lat/long pair as a Decimal Degree (DD)
 *
 * @generated from message bundles.v1.Location
 */
export type Location = Message<'bundles.v1.Location'> & {
  /**
   * @generated from field: double lat = 1;
   */
  lat: number

  /**
   * @generated from field: double lng = 2;
   */
  lng: number
}

/**
 * Describes the message bundles.v1.Location.
 * Use `create(LocationSchema)` to create a new message.
 */
export const LocationSchema: GenMessage<Location> =
  /*@__PURE__*/
  messageDesc(file_bundles_v1_rules, 0)

/**
 * Int32Range is a range of integers
 *
 * @generated from message bundles.v1.Int32Range
 */
export type Int32Range = Message<'bundles.v1.Int32Range'> & {
  /**
   * @generated from field: int32 start = 1;
   */
  start: number

  /**
   * @generated from field: int32 end = 2;
   */
  end: number
}

/**
 * Describes the message bundles.v1.Int32Range.
 * Use `create(Int32RangeSchema)` to create a new message.
 */
export const Int32RangeSchema: GenMessage<Int32Range> =
  /*@__PURE__*/
  messageDesc(file_bundles_v1_rules, 1)

/**
 * DayOfWeekValue is a value that represents a day of the week
 *
 * @generated from message bundles.v1.DayOfWeekValue
 */
export type DayOfWeekValue = Message<'bundles.v1.DayOfWeekValue'> & {
  /**
   * Deprecated: Use is instead
   *
   * @generated from field: int32 day_number = 1 [deprecated = true];
   * @deprecated
   */
  dayNumber: number

  /**
   * @generated from oneof bundles.v1.DayOfWeekValue.value
   */
  value:
    | {
        /**
         * @generated from field: int32 is = 2;
         */
        value: number
        case: 'is'
      }
    | {
        /**
         * @generated from field: int32 before = 3;
         */
        value: number
        case: 'before'
      }
    | {
        /**
         * @generated from field: int32 after = 4;
         */
        value: number
        case: 'after'
      }
    | {
        /**
         * @generated from field: bundles.v1.Int32Range between = 5;
         */
        value: Int32Range
        case: 'between'
      }
    | { case: undefined; value?: undefined }
}

/**
 * Describes the message bundles.v1.DayOfWeekValue.
 * Use `create(DayOfWeekValueSchema)` to create a new message.
 */
export const DayOfWeekValueSchema: GenMessage<DayOfWeekValue> =
  /*@__PURE__*/
  messageDesc(file_bundles_v1_rules, 2)

/**
 * TimeBound is a bounded point in time
 *
 * @generated from message bundles.v1.TimeBound
 */
export type TimeBound = Message<'bundles.v1.TimeBound'> & {
  /**
   * @generated from field: int32 hour = 1;
   */
  hour: number

  /**
   * @generated from field: int32 minute = 2;
   */
  minute: number
}

/**
 * Describes the message bundles.v1.TimeBound.
 * Use `create(TimeBoundSchema)` to create a new message.
 */
export const TimeBoundSchema: GenMessage<TimeBound> =
  /*@__PURE__*/
  messageDesc(file_bundles_v1_rules, 3)

/**
 * TimeBoundRange is a bounded range of time
 *
 * @generated from message bundles.v1.TimeBoundRange
 */
export type TimeBoundRange = Message<'bundles.v1.TimeBoundRange'> & {
  /**
   * @generated from field: bundles.v1.TimeBound start = 1;
   */
  start?: TimeBound

  /**
   * @generated from field: bundles.v1.TimeBound end = 2;
   */
  end?: TimeBound
}

/**
 * Describes the message bundles.v1.TimeBoundRange.
 * Use `create(TimeBoundRangeSchema)` to create a new message.
 */
export const TimeBoundRangeSchema: GenMessage<TimeBoundRange> =
  /*@__PURE__*/
  messageDesc(file_bundles_v1_rules, 4)

/**
 * HourOfDayValue is a value that represents an hour of the day
 *
 * @generated from message bundles.v1.HourOfDayValue
 */
export type HourOfDayValue = Message<'bundles.v1.HourOfDayValue'> & {
  /**
   * Deprecated: Use between instead
   *
   * @generated from field: bundles.v1.TimeBound lower_bound = 1 [deprecated = true];
   * @deprecated
   */
  lowerBound?: TimeBound

  /**
   * @generated from field: bundles.v1.TimeBound upper_bound = 2 [deprecated = true];
   * @deprecated
   */
  upperBound?: TimeBound

  /**
   * @generated from oneof bundles.v1.HourOfDayValue.value
   */
  value:
    | {
        /**
         * @generated from field: bundles.v1.TimeBound is = 3;
         */
        value: TimeBound
        case: 'is'
      }
    | {
        /**
         * @generated from field: bundles.v1.TimeBound before = 4;
         */
        value: TimeBound
        case: 'before'
      }
    | {
        /**
         * @generated from field: bundles.v1.TimeBound after = 5;
         */
        value: TimeBound
        case: 'after'
      }
    | {
        /**
         * @generated from field: bundles.v1.TimeBoundRange between = 6;
         */
        value: TimeBoundRange
        case: 'between'
      }
    | { case: undefined; value?: undefined }
}

/**
 * Describes the message bundles.v1.HourOfDayValue.
 * Use `create(HourOfDayValueSchema)` to create a new message.
 */
export const HourOfDayValueSchema: GenMessage<HourOfDayValue> =
  /*@__PURE__*/
  messageDesc(file_bundles_v1_rules, 5)

/**
 * DateRange is a range of dates
 *
 * @generated from message bundles.v1.DateRange
 */
export type DateRange = Message<'bundles.v1.DateRange'> & {
  /**
   * @generated from field: google.type.Date start = 1;
   */
  start?: Date

  /**
   * @generated from field: google.type.Date end = 2;
   */
  end?: Date
}

/**
 * Describes the message bundles.v1.DateRange.
 * Use `create(DateRangeSchema)` to create a new message.
 */
export const DateRangeSchema: GenMessage<DateRange> =
  /*@__PURE__*/
  messageDesc(file_bundles_v1_rules, 6)

/**
 * DateDuration is a duration of time relative to a reference date
 *
 * @generated from message bundles.v1.DateDuration
 */
export type DateDuration = Message<'bundles.v1.DateDuration'> & {
  /**
   * @generated from field: google.type.Date reference = 1;
   */
  reference?: Date

  /**
   * @generated from field: int32 value = 2;
   */
  value: number

  /**
   * @generated from field: bundles.v1.DateUnit unit = 3;
   */
  unit: DateUnit

  /**
   * @generated from field: bundles.v1.Operator operator = 4;
   */
  operator: Operator
}

/**
 * Describes the message bundles.v1.DateDuration.
 * Use `create(DateDurationSchema)` to create a new message.
 */
export const DateDurationSchema: GenMessage<DateDuration> =
  /*@__PURE__*/
  messageDesc(file_bundles_v1_rules, 7)

/**
 * DateValue is a value that represents a date
 *
 * @generated from message bundles.v1.DateValue
 */
export type DateValue = Message<'bundles.v1.DateValue'> & {
  /**
   * @generated from oneof bundles.v1.DateValue.value
   */
  value:
    | {
        /**
         * @generated from field: google.type.Date is = 1;
         */
        value: Date
        case: 'is'
      }
    | {
        /**
         * @generated from field: google.type.Date before = 2;
         */
        value: Date
        case: 'before'
      }
    | {
        /**
         * @generated from field: google.type.Date after = 3;
         */
        value: Date
        case: 'after'
      }
    | {
        /**
         * @generated from field: bundles.v1.DateRange between = 4;
         */
        value: DateRange
        case: 'between'
      }
    | {
        /**
         * @generated from field: bundles.v1.DateDuration since = 5;
         */
        value: DateDuration
        case: 'since'
      }
    | {
        /**
         * @generated from field: bundles.v1.DateDuration until = 6;
         */
        value: DateDuration
        case: 'until'
      }
    | { case: undefined; value?: undefined }
}

/**
 * Describes the message bundles.v1.DateValue.
 * Use `create(DateValueSchema)` to create a new message.
 */
export const DateValueSchema: GenMessage<DateValue> =
  /*@__PURE__*/
  messageDesc(file_bundles_v1_rules, 8)

/**
 * @generated from message bundles.v1.DeviceTypeValue
 */
export type DeviceTypeValue = Message<'bundles.v1.DeviceTypeValue'> & {
  /**
   * @generated from field: bundles.v1.DeviceType device_type = 1;
   */
  deviceType: DeviceType
}

/**
 * Describes the message bundles.v1.DeviceTypeValue.
 * Use `create(DeviceTypeValueSchema)` to create a new message.
 */
export const DeviceTypeValueSchema: GenMessage<DeviceTypeValue> =
  /*@__PURE__*/
  messageDesc(file_bundles_v1_rules, 9)

/**
 * @generated from message bundles.v1.GeoValue
 */
export type GeoValue = Message<'bundles.v1.GeoValue'> & {
  /**
   * @generated from oneof bundles.v1.GeoValue.value
   */
  value:
    | {
        /**
         * @generated from field: string region = 1;
         */
        value: string
        case: 'region'
      }
    | {
        /**
         * @generated from field: string state = 2;
         */
        value: string
        case: 'state'
      }
    | {
        /**
         * @generated from field: string county = 3;
         */
        value: string
        case: 'county'
      }
    | {
        /**
         * @generated from field: string zip = 4;
         */
        value: string
        case: 'zip'
      }
    | { case: undefined; value?: undefined }
}

/**
 * Describes the message bundles.v1.GeoValue.
 * Use `create(GeoValueSchema)` to create a new message.
 */
export const GeoValueSchema: GenMessage<GeoValue> =
  /*@__PURE__*/
  messageDesc(file_bundles_v1_rules, 10)

/**
 * @generated from message bundles.v1.NearbyValue
 */
export type NearbyValue = Message<'bundles.v1.NearbyValue'> & {
  /**
   * @generated from field: bundles.v1.Location location = 1;
   */
  location?: Location

  /**
   * @generated from field: double distance = 2;
   */
  distance: number

  /**
   * @generated from field: bundles.v1.DistanceUnit unit = 3;
   */
  unit: DistanceUnit

  /**
   * @generated from field: string full_address = 4;
   */
  fullAddress: string
}

/**
 * Describes the message bundles.v1.NearbyValue.
 * Use `create(NearbyValueSchema)` to create a new message.
 */
export const NearbyValueSchema: GenMessage<NearbyValue> =
  /*@__PURE__*/
  messageDesc(file_bundles_v1_rules, 11)

/**
 * @generated from message bundles.v1.RequestValue
 */
export type RequestValue = Message<'bundles.v1.RequestValue'> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string

  /**
   * @generated from field: bundles.v1.Operator operator = 2;
   */
  operator: Operator

  /**
   * @generated from field: google.protobuf.Value value = 3;
   */
  value?: Value
}

/**
 * Describes the message bundles.v1.RequestValue.
 * Use `create(RequestValueSchema)` to create a new message.
 */
export const RequestValueSchema: GenMessage<RequestValue> =
  /*@__PURE__*/
  messageDesc(file_bundles_v1_rules, 12)

/**
 * @generated from message bundles.v1.RequestContextValue
 */
export type RequestContextValue = Message<'bundles.v1.RequestContextValue'> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string

  /**
   * @generated from field: bundles.v1.Operator operator = 2;
   */
  operator: Operator

  /**
   * @generated from field: google.protobuf.Value value = 3;
   */
  value?: Value
}

/**
 * Describes the message bundles.v1.RequestContextValue.
 * Use `create(RequestContextValueSchema)` to create a new message.
 */
export const RequestContextValueSchema: GenMessage<RequestContextValue> =
  /*@__PURE__*/
  messageDesc(file_bundles_v1_rules, 13)

/**
 * @generated from message bundles.v1.ContactPropertyValue
 */
export type ContactPropertyValue = Message<'bundles.v1.ContactPropertyValue'> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string

  /**
   * @generated from field: bundles.v1.Operator operator = 2;
   */
  operator: Operator

  /**
   * @generated from field: google.protobuf.Value value = 3;
   */
  value?: Value
}

/**
 * Describes the message bundles.v1.ContactPropertyValue.
 * Use `create(ContactPropertyValueSchema)` to create a new message.
 */
export const ContactPropertyValueSchema: GenMessage<ContactPropertyValue> =
  /*@__PURE__*/
  messageDesc(file_bundles_v1_rules, 14)

/**
 * @generated from message bundles.v1.CompoundRuleValue
 */
export type CompoundRuleValue = Message<'bundles.v1.CompoundRuleValue'> & {
  /**
   * @generated from field: bundles.v1.Condition lhs = 1;
   */
  lhs?: Condition

  /**
   * @generated from field: bundles.v1.BooleanOperator operator = 2;
   */
  operator: BooleanOperator

  /**
   * @generated from field: bundles.v1.Condition rhs = 3;
   */
  rhs?: Condition
}

/**
 * Describes the message bundles.v1.CompoundRuleValue.
 * Use `create(CompoundRuleValueSchema)` to create a new message.
 */
export const CompoundRuleValueSchema: GenMessage<CompoundRuleValue> =
  /*@__PURE__*/
  messageDesc(file_bundles_v1_rules, 15)

/**
 * @generated from message bundles.v1.NotValue
 */
export type NotValue = Message<'bundles.v1.NotValue'> & {
  /**
   * @generated from field: bundles.v1.Condition condition = 1;
   */
  condition?: Condition
}

/**
 * Describes the message bundles.v1.NotValue.
 * Use `create(NotValueSchema)` to create a new message.
 */
export const NotValueSchema: GenMessage<NotValue> =
  /*@__PURE__*/
  messageDesc(file_bundles_v1_rules, 16)

/**
 * @generated from message bundles.v1.RuleValue
 */
export type RuleValue = Message<'bundles.v1.RuleValue'> & {
  /**
   * @generated from oneof bundles.v1.RuleValue.type
   */
  type:
    | {
        /**
         * @generated from field: bundles.v1.DayOfWeekValue day_of_week_value = 1;
         */
        value: DayOfWeekValue
        case: 'dayOfWeekValue'
      }
    | {
        /**
         * @generated from field: bundles.v1.HourOfDayValue hour_of_day_value = 2;
         */
        value: HourOfDayValue
        case: 'hourOfDayValue'
      }
    | {
        /**
         * @generated from field: bundles.v1.DeviceTypeValue device_type_value = 3;
         */
        value: DeviceTypeValue
        case: 'deviceTypeValue'
      }
    | {
        /**
         * @generated from field: bundles.v1.GeoValue geo_value = 4;
         */
        value: GeoValue
        case: 'geoValue'
      }
    | {
        /**
         * @generated from field: bundles.v1.NearbyValue nearby_value = 5;
         */
        value: NearbyValue
        case: 'nearbyValue'
      }
    | {
        /**
         * @generated from field: bundles.v1.RequestValue request_value = 6;
         */
        value: RequestValue
        case: 'requestValue'
      }
    | {
        /**
         * @generated from field: bundles.v1.RequestContextValue context_value = 7;
         */
        value: RequestContextValue
        case: 'contextValue'
      }
    | {
        /**
         * @generated from field: bundles.v1.CompoundRuleValue compound_value = 8;
         */
        value: CompoundRuleValue
        case: 'compoundValue'
      }
    | {
        /**
         * @generated from field: bundles.v1.NotValue not_value = 9;
         */
        value: NotValue
        case: 'notValue'
      }
    | {
        /**
         * @generated from field: bundles.v1.DateValue date_value = 10;
         */
        value: DateValue
        case: 'dateValue'
      }
    | {
        /**
         * @generated from field: bundles.v1.ContactPropertyValue contact_property_value = 11;
         */
        value: ContactPropertyValue
        case: 'contactPropertyValue'
      }
    | { case: undefined; value?: undefined }
}

/**
 * Describes the message bundles.v1.RuleValue.
 * Use `create(RuleValueSchema)` to create a new message.
 */
export const RuleValueSchema: GenMessage<RuleValue> =
  /*@__PURE__*/
  messageDesc(file_bundles_v1_rules, 17)

/**
 * @generated from message bundles.v1.Condition
 */
export type Condition = Message<'bundles.v1.Condition'> & {
  /**
   * @generated from field: bundles.v1.RuleType rule_type = 1;
   */
  ruleType: RuleType

  /**
   * @generated from field: repeated bundles.v1.RuleValue values = 2;
   */
  values: RuleValue[]

  /**
   * @generated from field: string label = 3;
   */
  label: string
}

/**
 * Describes the message bundles.v1.Condition.
 * Use `create(ConditionSchema)` to create a new message.
 */
export const ConditionSchema: GenMessage<Condition> =
  /*@__PURE__*/
  messageDesc(file_bundles_v1_rules, 18)

/**
 * @generated from message bundles.v1.Actor
 */
export type Actor = Message<'bundles.v1.Actor'> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string

  /**
   * @generated from oneof bundles.v1.Actor.value
   */
  value:
    | {
        /**
         * @generated from field: string email = 2;
         */
        value: string
        case: 'email'
      }
    | { case: undefined; value?: undefined }
}

/**
 * Describes the message bundles.v1.Actor.
 * Use `create(ActorSchema)` to create a new message.
 */
export const ActorSchema: GenMessage<Actor> = /*@__PURE__*/ messageDesc(file_bundles_v1_rules, 19)

/**
 * @generated from message bundles.v1.Sender
 */
export type Sender = Message<'bundles.v1.Sender'> & {
  /**
   * @generated from field: bundles.v1.Actor from = 1;
   */
  from?: Actor

  /**
   * @generated from field: bundles.v1.Actor reply_to = 2;
   */
  replyTo?: Actor

  /**
   * @generated from field: string ip_group_id = 3;
   */
  ipGroupId: string
}

/**
 * Describes the message bundles.v1.Sender.
 * Use `create(SenderSchema)` to create a new message.
 */
export const SenderSchema: GenMessage<Sender> = /*@__PURE__*/ messageDesc(file_bundles_v1_rules, 20)

/**
 * @generated from message bundles.v1.NotifyAction
 */
export type NotifyAction = Message<'bundles.v1.NotifyAction'> & {
  /**
   * @generated from field: bundles.v1.NotificationType notification_type = 1;
   */
  notificationType: NotificationType

  /**
   * @generated from field: bundles.v1.Sender sender = 2;
   */
  sender?: Sender

  /**
   * @generated from field: repeated bundles.v1.Actor recipients = 3;
   */
  recipients: Actor[]

  /**
   * @generated from field: string subject = 4;
   */
  subject: string

  /**
   * @generated from field: string template_id = 5;
   */
  templateId: string

  /**
   * @generated from field: string default_template_id = 9;
   */
  defaultTemplateId: string

  /**
   * @generated from field: string body = 10;
   */
  body: string

  /**
   * @generated from field: google.protobuf.Duration delay = 6;
   */
  delay?: Duration

  /**
   * @generated from field: int64 suppression_group_id = 7;
   */
  suppressionGroupId: bigint

  /**
   * @generated from field: repeated bundles.v1.Actor ccs = 8;
   */
  ccs: Actor[]

  /**
   * @generated from field: repeated bundles.v1.Actor bccs = 11;
   */
  bccs: Actor[]
}

/**
 * Describes the message bundles.v1.NotifyAction.
 * Use `create(NotifyActionSchema)` to create a new message.
 */
export const NotifyActionSchema: GenMessage<NotifyAction> =
  /*@__PURE__*/
  messageDesc(file_bundles_v1_rules, 21)

/**
 * @generated from message bundles.v1.Action
 */
export type Action = Message<'bundles.v1.Action'> & {
  /**
   * @generated from field: string name = 5;
   */
  name: string

  /**
   * @generated from field: repeated bundles.v1.Condition conditions = 1;
   */
  conditions: Condition[]

  /**
   * @generated from field: bool disabled = 4;
   */
  disabled: boolean

  /**
   * @generated from oneof bundles.v1.Action.type
   */
  type:
    | {
        /**
         * @generated from field: bundles.v1.NotifyAction notify_action = 2;
         */
        value: NotifyAction
        case: 'notifyAction'
      }
    | { case: undefined; value?: undefined }
}

/**
 * Describes the message bundles.v1.Action.
 * Use `create(ActionSchema)` to create a new message.
 */
export const ActionSchema: GenMessage<Action> = /*@__PURE__*/ messageDesc(file_bundles_v1_rules, 22)

/**
 * Operator specifies the comparison type used when evaluating rules
 *
 * @generated from enum bundles.v1.Operator
 */
export enum Operator {
  /**
   * @generated from enum value: OPERATOR_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: OPERATOR_EQ = 1;
   */
  EQ = 1,

  /**
   * @generated from enum value: OPERATOR_NEQ = 2;
   */
  NEQ = 2,

  /**
   * @generated from enum value: OPERATOR_GT = 3;
   */
  GT = 3,

  /**
   * @generated from enum value: OPERATOR_LT = 4;
   */
  LT = 4,

  /**
   * @generated from enum value: OPERATOR_GTE = 5;
   */
  GTE = 5,

  /**
   * @generated from enum value: OPERATOR_LTE = 6;
   */
  LTE = 6,

  /**
   * @generated from enum value: OPERATOR_REGEX = 7;
   */
  REGEX = 7,

  /**
   * @generated from enum value: OPERATOR_CONTAINS = 8;
   */
  CONTAINS = 8,

  /**
   * @generated from enum value: OPERATOR_IS_EMPTY = 9;
   */
  IS_EMPTY = 9,

  /**
   * @generated from enum value: OPERATOR_NOT_EMPTY = 10;
   */
  NOT_EMPTY = 10,

  /**
   * @generated from enum value: OPERATOR_TIME_SINCE = 11;
   */
  TIME_SINCE = 11,

  /**
   * @generated from enum value: OPERATOR_TIME_UNTIL = 12;
   */
  TIME_UNTIL = 12
}

/**
 * Describes the enum bundles.v1.Operator.
 */
export const OperatorSchema: GenEnum<Operator> = /*@__PURE__*/ enumDesc(file_bundles_v1_rules, 0)

/**
 * BooleanOperator specifies the boolean operation used when evaluating rules
 *
 * @generated from enum bundles.v1.BooleanOperator
 */
export enum BooleanOperator {
  /**
   * @generated from enum value: BOOLEAN_OPERATOR_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BOOLEAN_OPERATOR_AND = 1;
   */
  AND = 1,

  /**
   * @generated from enum value: BOOLEAN_OPERATOR_OR = 2;
   */
  OR = 2
}

/**
 * Describes the enum bundles.v1.BooleanOperator.
 */
export const BooleanOperatorSchema: GenEnum<BooleanOperator> =
  /*@__PURE__*/
  enumDesc(file_bundles_v1_rules, 1)

/**
 * DateUnit specifies the unit of time for date durations
 *
 * @generated from enum bundles.v1.DateUnit
 */
export enum DateUnit {
  /**
   * @generated from enum value: DATE_UNIT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DATE_UNIT_DAYS = 1;
   */
  DAYS = 1,

  /**
   * @generated from enum value: DATE_UNIT_WEEKS = 2;
   */
  WEEKS = 2,

  /**
   * @generated from enum value: DATE_UNIT_MONTHS = 3;
   */
  MONTHS = 3,

  /**
   * @generated from enum value: DATE_UNIT_YEARS = 4;
   */
  YEARS = 4
}

/**
 * Describes the enum bundles.v1.DateUnit.
 */
export const DateUnitSchema: GenEnum<DateUnit> = /*@__PURE__*/ enumDesc(file_bundles_v1_rules, 2)

/**
 * @generated from enum bundles.v1.DeviceType
 */
export enum DeviceType {
  /**
   * @generated from enum value: DEVICE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DEVICE_TYPE_IOS = 1;
   */
  IOS = 1,

  /**
   * @generated from enum value: DEVICE_TYPE_ANDROID = 2;
   */
  ANDROID = 2,

  /**
   * @generated from enum value: DEVICE_TYPE_DESKTOP = 3;
   */
  DESKTOP = 3
}

/**
 * Describes the enum bundles.v1.DeviceType.
 */
export const DeviceTypeSchema: GenEnum<DeviceType> =
  /*@__PURE__*/
  enumDesc(file_bundles_v1_rules, 3)

/**
 * @generated from enum bundles.v1.DistanceUnit
 */
export enum DistanceUnit {
  /**
   * @generated from enum value: DISTANCE_UNIT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DISTANCE_UNIT_MILES = 1;
   */
  MILES = 1,

  /**
   * @generated from enum value: DISTANCE_UNIT_METERS = 2;
   */
  METERS = 2,

  /**
   * @generated from enum value: DISTANCE_UNIT_KILOMETERS = 3;
   */
  KILOMETERS = 3
}

/**
 * Describes the enum bundles.v1.DistanceUnit.
 */
export const DistanceUnitSchema: GenEnum<DistanceUnit> =
  /*@__PURE__*/
  enumDesc(file_bundles_v1_rules, 4)

/**
 * @generated from enum bundles.v1.RuleType
 */
export enum RuleType {
  /**
   * @generated from enum value: RULE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RULE_TYPE_DAY_OF_WEEK = 1;
   */
  DAY_OF_WEEK = 1,

  /**
   * @generated from enum value: RULE_TYPE_HOUR_OF_DAY = 2;
   */
  HOUR_OF_DAY = 2,

  /**
   * @generated from enum value: RULE_TYPE_DEVICE_TYPE = 3;
   */
  DEVICE_TYPE = 3,

  /**
   * @generated from enum value: RULE_TYPE_GEO = 4;
   */
  GEO = 4,

  /**
   * @generated from enum value: RULE_TYPE_NEARBY = 5;
   */
  NEARBY = 5,

  /**
   * @generated from enum value: RULE_TYPE_REQUEST = 6;
   */
  REQUEST = 6,

  /**
   * @generated from enum value: RULE_TYPE_DYNAMIC_PAGE_REQUEST = 7;
   */
  DYNAMIC_PAGE_REQUEST = 7,

  /**
   * @generated from enum value: RULE_TYPE_REQUEST_CONTEXT = 8;
   */
  REQUEST_CONTEXT = 8,

  /**
   * @generated from enum value: RULE_TYPE_COMPOUND = 9;
   */
  COMPOUND = 9,

  /**
   * @generated from enum value: RULE_TYPE_NOT = 10;
   */
  NOT = 10,

  /**
   * @generated from enum value: RULE_TYPE_DATE = 11;
   */
  DATE = 11,

  /**
   * @generated from enum value: RULE_TYPE_CONTACT_PROPERTY = 12;
   */
  CONTACT_PROPERTY = 12
}

/**
 * Describes the enum bundles.v1.RuleType.
 */
export const RuleTypeSchema: GenEnum<RuleType> = /*@__PURE__*/ enumDesc(file_bundles_v1_rules, 5)

/**
 * @generated from enum bundles.v1.NotificationType
 */
export enum NotificationType {
  /**
   * @generated from enum value: NOTIFICATION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTIFICATION_TYPE_EMAIL = 1;
   */
  EMAIL = 1
}

/**
 * Describes the enum bundles.v1.NotificationType.
 */
export const NotificationTypeSchema: GenEnum<NotificationType> =
  /*@__PURE__*/
  enumDesc(file_bundles_v1_rules, 6)
